import React, { useState, useEffect } from "react";
import PersonalInfoForm from "./PersonalInfoForm";
import { emailMasking } from "../../../../util/CommonReadonlyMasking";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import { GetCountryListAndInternationalSupport } from "../../../../util/countryListAndInternationalSupport";
import { ezsServiceIds, idfServiceIds } from "../../../../config/UserServicesList";
import { useAreServicesActive } from "../../../../util/CommonServices";
import { MonitoringData } from "../../../../store/common";
import moment from "moment";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const PersonalInfo: React.FunctionComponent<{ monitoringData: MonitoringData; ensureDataFetch: any }> = (props) => {
    const [personalAssets, setPersonalAssets] = useState();
    const [addressInfo, setAddressInfo] = useState({});
    const [personalInfo, setPersonalInfo] = useState(false);
    const [info, setInfo]: any = useState({});
    const [isLoading, setisLoading] = useState(false);
    // const [monitoringData, setMonitoringData] = useState(props.monitoringData);
    const { t: tLang } = useTranslation();

    const { getCountries } = GetCountryListAndInternationalSupport();

    const isPrimaryAccount: boolean = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const isChildAccount: boolean = !isPrimaryAccount;
    const childAccountAutogeneratedEmail: string = useSelector((state: ApplicationState) =>
        state.loggedInUser &&
        state.loggedInUser.activeAccount &&
        state.loggedInUser.activeAccount.accountType !== "PRIMARY" &&
        state.loggedInUser.activeAccount.email
            ? state.loggedInUser.activeAccount.email
            : ""
    );
    // For IDF partner checking if the monitoring for the different fields is active or not.
    const isDarkWebMonitoringActive = useAreServicesActive([
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.darkWebMonitoring,
        idfServiceIds.darkWebMonitoring,
    ]);

    const phoneMonitoringServiceActive = useAreServicesActive([
        idfServiceIds.phoneNumberMonitoring,
        idfServiceIds.darkWebMonitoring,
        idfServiceIds.shortTermLoanMonitoring,
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebPhiBot,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.basicPublicRecordsMonitoring,
        ezsServiceIds.tuCriminalMonitoring,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditScoreSimulator,
        ezsServiceIds.tuCreditScoreTracker,
    ]);

    const isDOBAndSSNDisplayable = useAreServicesActive([
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        idfServiceIds.childCreditActivityMonitoring,
        idfServiceIds.shortTermLoanMonitoring,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.tuCriminalMonitoring,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditScoreSimulator,
        ezsServiceIds.tuCreditScoreTracker,
    ]);
    const emailAddressMonitoringActive = useAreServicesActive([idfServiceIds.emailAddressMonitoring]);

    const isPhoneMonitoringActive = phoneMonitoringServiceActive;
    const isEmailAddressMonitoringActive = isDarkWebMonitoringActive ? true : emailAddressMonitoringActive;

    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const defaultCountryCode: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.defaultCountryCode
            ? state.configurationState.configuration.partnerConfig.defaultCountryCode.length > 0
                ? state.configurationState.configuration.partnerConfig.defaultCountryCode
                : "US"
            : "US"
    );

    function isAutoGeneratedChildEmail(email: string) {
        return isChildAccount && childAccountAutogeneratedEmail && email.toLowerCase() === childAccountAutogeneratedEmail.toLowerCase();
    }

    const getMonitoredEmailList = (data: any) => {
        const monitoredEmails = data
            ? data["additional-emails-address"]
                ? [data["primary-email-address"], ...data["additional-emails-address"]]
                : data["primary-email-address"]
                ? [data["primary-email-address"]]
                : [{ email: "" }]
            : [{ email: "" }];
        const filteredEmails = monitoredEmails.filter(function (item, index, arr) {
            return item && !isAutoGeneratedChildEmail(item.email);
        });
        return filteredEmails.length > 0 ? filteredEmails : [{ email: "" }];
    };

    const ensureDataFetched = () => {
        setisLoading(true);
        props.ensureDataFetch();
    };

    useEffect(() => {
        setInfo(props.monitoringData);
        const dataAsset = props.monitoringData.asset;
        setPersonalAssets(dataAsset.personalInformation);
        setAddressInfo(dataAsset.addressInformation);
        setisLoading(false);
    }, [props.monitoringData]);

    const [formData, setFormData] = useState({
        "date-of-birth": "",
        "address-country": "",
        emails: [{ email: "" }],
        firstName: "",
        lastName: "",
        phone: [{ phone: "", code: "" }],
        securityNumber: "",
        "ezshield-id": "",
        "idf-user-id": "",
        internationalSecurityNumber: { sin: "" },
        nationalIdentificationNumber: { nid: "" },
    });

    useEffect(() => {
        const data: any = personalAssets;
        const addressData: any = addressInfo;
        // get default phone number list
        const phoneArray: any = data
            ? data["additional-phone"]
                ? [data["primary-phone"], ...data["additional-phone"]]
                : data["primary-phone"]
                ? [data["primary-phone"]]
                : [{ phone: "" }]
            : [{ phone: "" }];
        // get all country list and find country calling code
        const { countryList } = getCountries;
        const countryInfo: any = countryList.find((c: any) => c.countryCode === defaultCountryCode);
        //map array with update phone numbers
        phoneArray.map((p: any) => {
            if (p.phone && !p.phone.includes("+")) p.phone = `+${countryInfo.countryCallingCode}${p.phone}`;
        });

        setFormData({
            "ezshield-id": info && info["ezshield-id"],
            "idf-user-id": info && info["idf-user-id"],
            "date-of-birth": data && data["date-of-birth"] && data["date-of-birth"],
            "address-country": addressData && addressData["address-country"],
            emails: getMonitoredEmailList(data),
            firstName: data ? data["first-name"] : "",
            lastName: data ? data["last-name"] : "",
            phone: phoneArray,
            securityNumber: data ? data["ssn"] : formData.securityNumber,
            internationalSecurityNumber: data && data["monitoring-sin"] ? data["monitoring-sin"] : {},
            nationalIdentificationNumber: data && data["monitoring-nid"] ? data["monitoring-nid"] : {},
        });
    }, [personalAssets]);

    /***handling the email field***/
    return (
        <div className={`box offset-padding ${isLoading && "loading"}`}>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName={"user"} />
                    </div>
                    <div className="box-title-text has-actions">
                        <h2 className="box-title">{tLang("identityVault.monitoredInformation.personalInfoWidget.title")}</h2>
                    </div>
                </div>
                <div className="box-description">
                    <p> {tLang("identityVault.monitoredInformation.personalInfoWidget.message")}</p>
                </div>
                {!personalInfo && (
                    <div className="box-actions">
                        <button
                            type="button"
                            className="btn-default btn-grey-dot"
                            id="monitored-info-personal-information"
                            onClick={() => {
                                setPersonalInfo(true);
                                window.addToDataLayer({ event: "Edit Personal Information" });
                            }}
                        >
                            <span className="btn-text">
                                {tLang("identityVault.monitoredInformation.personalInfoWidget.editLinkText")} <span className="sr-only">Personal Information</span>
                            </span>
                            <span className="btn-icon">
                                <RenderIcons iconName="pen" />
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="box-content">
                {!personalInfo ? (
                    <div role="grid" className="data-grid " id="monitored-info-personal-information-grid" aria-hidden="false">
                        {!isLife360PartnerId && (
                            <div role="row" className="data-row row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div role="gridcell" className="data-label" id="label-full-name-display">
                                        {tLang("identityVault.monitoredInformation.personalInfoWidget.label.fullName")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-full-name-display">
                                        {`${formData.firstName && formData.firstName}
                                          ${formData.lastName && formData.lastName}
                                        `}
                                    </div>
                                </div>
                            </div>
                        )}

                        {isEmailAddressMonitoringActive && formData.emails && formData.emails.length > 0
                            ? formData!.emails!.map((email: any, index: number) => {
                                  return (
                                      <div role="row" key={index} className="data-row row">
                                          <div className="col-xs-12 col-sm-4 col-no-gutter">
                                              <div role="gridcell" className="data-label" id={`label-email-display-${index + 1}`}>
                                                  {index === 0 && tLang("identityVault.monitoredInformation.personalInfoWidget.label.email")}
                                              </div>
                                          </div>
                                          <div className="col-xs-12 col-sm-8 col-no-gutter">
                                              <div role="gridcell" className="data-value" aria-labelledby={`label-email-display-${index + 1}`} style={{ maxWidth: "70vw" }}>
                                                  {email && email.email && emailMasking(email.email)}
                                              </div>
                                          </div>
                                      </div>
                                  );
                              })
                            : isEmailAddressMonitoringActive && (
                                  <div role="row" className="data-row row">
                                      <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div role="gridcell" className="data-label" id="label-email-display">
                                              {tLang("identityVault.monitoredInformation.personalInfoWidget.label.email")}
                                          </div>
                                      </div>
                                      <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-email-display">
                                              -
                                          </div>
                                      </div>
                                  </div>
                              )}

                        {isPhoneMonitoringActive && formData.phone && formData.phone.length > 0
                            ? formData.phone.map((phone: any, index: number) => {
                                  if (phone && !!phone.phone) phone.phone = phone.phone.replace(/[^0-9+]/g, "");
                                  return (
                                      <div key={index} role="row" className="data-row row">
                                          <div className="col-xs-12 col-sm-4 col-no-gutter">
                                              <div role="gridcell" className="data-label" id={`label-phone-display-${index + 1}`}>
                                                  {index === 0 && tLang("identityVault.monitoredInformation.personalInfoWidget.label.phone")}
                                              </div>
                                          </div>
                                          <div className="col-xs-12 col-sm-8 col-no-gutter">
                                              <div role="gridcell" className="data-value" aria-labelledby={`label-phone-display-${index + 1}`}>
                                                  {phone.phone &&
                                                      `${"*".repeat(phone.phone.substr(0, phone.phone.length - 4).length)}${phone.phone.substr(
                                                          phone.phone.length - 4
                                                      )}`}
                                              </div>
                                          </div>
                                      </div>
                                  );
                              })
                            : isPhoneMonitoringActive && (
                                  <div role="row" className="data-row row">
                                      <div className="col-xs-12 col-sm-4 col-no-gutter">
                                          <div role="gridcell" className="data-label" id="label-phone-display">
                                              {tLang("identityVault.monitoredInformation.personalInfoWidget.label.email")}
                                          </div>
                                      </div>
                                      <div className="col-xs-12 col-sm-8 col-no-gutter">
                                          <div role="gridcell" className="data-value" aria-labelledby="label-phone-display">
                                              -
                                          </div>
                                      </div>
                                  </div>
                              )}

                        {!isLife360PartnerId && (isDOBAndSSNDisplayable || isDarkWebMonitoringActive) && (
                            <div role="row" className="data-row row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div role="gridcell" className="data-label" id="label-dob-display">
                                        {tLang("identityVault.monitoredInformation.personalInfoWidget.label.dob")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-dob-display">
                                        {!!formData["date-of-birth"]
                                            ? formData["address-country"] === "US"
                                                ? moment(formData["date-of-birth"]).format("MMM DD ****")
                                                : formData["address-country"] === "CA" || formData["address-country"] === "TW"
                                                ? moment(formData["date-of-birth"]).format("**** MMM DD")
                                                : moment(formData["date-of-birth"]).format("DD MMM ****")
                                            : ""}
                                    </div>
                                </div>
                            </div>
                        )}

                        {!isLife360PartnerId && (isDOBAndSSNDisplayable || isDarkWebMonitoringActive) && (
                            <>
                                {(formData["address-country"] === "US" ||formData["address-country"] === "United States of America" ||
                                (!isPrimaryAccount && Boolean(formData.securityNumber)) || Boolean(formData.securityNumber))  && (
                                    <div role="row" className="data-row row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id="label-ssn-display">
                                                {tLang("identityVault.monitoredInformation.personalInfoWidget.label.ssn")}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby="label-ssn-display">
                                                {formData.securityNumber ? `XXX - XX - ${formData.securityNumber.substr(formData.securityNumber.length - 4)}` : ""}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(formData["address-country"] === "CA" || formData["address-country"] === "Canada" || Boolean(formData.internationalSecurityNumber["sin"])) && (
                                    <div role="row" className="data-row row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id="label-sin-display">
                                                {tLang("identityVault.monitoredInformation.personalInfoWidget.label.sin")}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby="label-sin-display">
                                                {formData.internationalSecurityNumber["sin"]
                                                    ? `XXX - XXX - ${formData.internationalSecurityNumber["sin"].substr(
                                                          formData.internationalSecurityNumber["sin"].length - 3
                                                      )}`
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {((formData["address-country"] !== "CA" && formData["address-country"] !== "Canada" && formData["address-country"] !== "US" && formData["address-country"] !== "United States of America" && isPrimaryAccount) ||
                                    Boolean(formData.nationalIdentificationNumber["nid"])) && (
                                    <div role="row" className="data-row row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id="label-nid-display">
                                                {tLang("identityVault.monitoredInformation.personalInfoWidget.label.nid")}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby="label-nid-display">
                                                {formData.nationalIdentificationNumber["nid"]
                                                    ? `XXX XXX ${formData.nationalIdentificationNumber["nid"].substr(6)}`
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ) : (
                    <PersonalInfoForm
                        refreshDataCallback={ensureDataFetched}
                        setStatus={setPersonalInfo}
                        addressInfo={addressInfo}
                        status={personalInfo}
                        formData={formData}
                        setFormData={setFormData}
                        activeStatus={{ isPhoneMonitoringActive, isEmailAddressMonitoringActive, isDOBAndSSNDisplayable, isDarkWebMonitoringActive }}
                    />
                )}
            </div>
        </div>
    );
};

export default PersonalInfo;
